interface EnvConfig {
  apiHost: string;
  notificationsApiHost: string;
  reasoningEngineUrl: string;
  fileUploadBucket: string;
  googleClientId: string;
  metaAppId: string;
  metaConfigId: string;
  apiKey: string;
}

const envConfig: EnvConfig = {
  apiHost: process.env.REACT_APP_API_HOST || '',
  notificationsApiHost: process.env.REACT_APP_NOTIFICATIONS_API_HOST || '',
  reasoningEngineUrl: process.env.REACT_APP_REASONING_ENGINE_URL || '',
  fileUploadBucket: process.env.REACT_APP_FILE_UPLOAD_BUCKET || '',
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  metaAppId: process.env.REACT_APP_META_APP_ID || '',
  metaConfigId: process.env.REACT_APP_META_CONFIG_ID || '',
  apiKey: process.env.REACT_APP_API_KEY || '',
};

export default envConfig;
